var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","scroll":"no"}},[_c('keep-alive',{attrs:{"exclude":"Market,marketCommission,marketMy,marketApply"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }